import { DialogContent } from '@mui/material';
import { ReactNode } from 'react';

interface Props {
  children: ReactNode;
  small?: boolean;
}

export const ModalContent: React.FC<Props> = ({ children, small = false }) => {
  return (
    <DialogContent sx={{ padding: small ? '1rem 1.5rem 1.5rem 1.5rem !important' : '1.5rem !important' }}>
      {children}
    </DialogContent>
  );
};
